// extracted by mini-css-extract-plugin
export var Section = "FourthScreen-module--Section--WA8f7";
export var Inner = "FourthScreen-module--Inner--vj4JW";
export var Row = "FourthScreen-module--Row--Yp3pI";
export var Total = "FourthScreen-module--Total--oaEY3";
export var TotalNum = "FourthScreen-module--TotalNum--o3FD4";
export var TotalText = "FourthScreen-module--TotalText--sc2mN";
export var Details = "FourthScreen-module--Details--gyYhO";
export var Line = "FourthScreen-module--Line--27CCl";
export var DetailsItem = "FourthScreen-module--DetailsItem--fXgVm";
export var DetailsItemNum = "FourthScreen-module--DetailsItemNum--7mDMr";
export var DetailsItemText = "FourthScreen-module--DetailsItemText--uVYlT";
export var arrowLeft = "FourthScreen-module--arrowLeft--rUZlu";
export var arrowRight = "FourthScreen-module--arrowRight--3HK6m";